<template>
  <div class="boxResumo">
     <v-layout column align-center>
       <v-flex xs12>
        <div class="right p-l-10">
          <v-btn slot="activator" color="primary" class="mb-2" v-print @click="VisivelOK=true;confirmaEdicaoImpressaoTermo();">Salvar PDF
            <v-icon dark right>print</v-icon>
          </v-btn>
        </div>

          <div class="right p-l-10">
            <v-btn
              slot="activator"
              color="primary"
              class="mb-2"
              @click="editarTermo()"
            >Editar</v-btn>
          </div>
        <div >

          <v-btn slot="activator" color="primary" class="mb-2" @click="emitFecharModalToParent();">OK
            <v-icon dark right></v-icon>
          </v-btn>
       
        </div>

      </v-flex>

      <!-- <div id="conteudoImpressao"> -->
        <v-flex id="conteudoImpressao" xs12 class="textoBoasVindas">
        
        <table  border="1" width="800" align="left"  >
          <thead>
            <tr style="border: 2px solid #cdcdcd">
              <td width="200" >     
                  <img src="/images/logoTopo.png" width="200" >
              </td>
              <td>    
                  <h2>Termo de Declaração de Concordância e Veracidade</h2>
              </td>  
                <td>
                <img src="/images/banner-cafdigital-vertical.png" width="200">
              </td>            
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="3">     
                  <table border="1" align="left" cellpadding="0" cellspacing="0" width="100%"> 
                      <tr> 
                        <td ALIGN="LEFT" colspan="3">
                          <strong>Nome:</strong> {{model ? model.nome : ''}}
                        </td>
                      </tr>
                      <tr>
                        <td ALIGN="LEFT" colspan="2">
                          <strong>RG:</strong> {{model ? model.rg : ''}}
                        </td> 
                        <td ALIGN="LEFT">
                          <strong>CPF:</strong> {{model ? model.cpf : ''}}
                        </td>
                      </tr>
                      <tr> 
                        <td ALIGN="LEFT" colspan="2">
                          <strong>Razão Social:</strong> {{model ? model.razaO_SOCIAL : ''}}
                        </td>
                        <td align="left">
                          <strong>CNPJ:</strong> {{model ? model.cnpj : ''}}
                        </td>
                      </tr>
                      <tr> 
                        <td ALIGN="LEFT" colspan="3">
                          <strong>Endereço:</strong> {{model ? model.endereco : ''}}  
                        </td>
                      </tr>
                      <tr>
                        <td ALIGN="LEFT" colspan="2">
                          <strong>Bairro:</strong> {{model ? model.bairro : ''}}                        
                        </td>
                        <td ALIGN="LEFT">
                          <strong>Cidade:</strong> {{model ? model.cidade : ''}}
                        </td>
                      </tr>
                      <tr> 
                        <td ALIGN="LEFT">
                          <strong>Estado:</strong> {{model ? model.estado : ''}}
                        </td>
                        <td ALIGN="LEFT">
                          <strong>CEP:</strong> {{model ? model.cep : ''}}
                        </td>
                        <td ALIGN="LEFT">
                          <strong>Telefone:</strong> {{model ? model.telefone : ''}}
                        </td>
                      </tr>
                      <tr> 
                        <td ALIGN="LEFT" colspan="2">
                          <strong>E-mail:</strong> {{model ? model.email : ''}}
                        </td>
                        <td ALIGN="LEFT">
                          <strong>Celular:</strong> {{model ? model.celular : ''}}
                        </td>
                      </tr>
                      <tr> 
                        <td ALIGN="LEFT"  colspan="3" style="padding:5px">
                          <br>
                          
                          <p align="justify">A realização do registro como fornecedor (pessoa fisica ou juridica, nacional ou estrangeira)
                            ativo no Cadastro de Fornecedores do Estado da Bahia - CAF e a entrega deste documento, importa na aceitação de todos os
                            termos e condições que regem o Cadastro de Fornecedores do Estado da Bahia - CAF, conforme Lei Estadual nº 14.634,
                            de 28 de novembro de 2023 em consonância com a Lei Federal 14.133, de 1º de abril de 2021 e demais instrumentos legais vigentes,
                            admitindo como válida a assinatura eletrônica cadastrada (login/senha).</p>
                            <p align="justify">Ao submeter a solicitação, o fornecedor (pessoa fisica ou juridica, nacional ou estrangeira) admite-se como 
                            responsável pelas ações efetuadas no Comprasnet.BA, bem como atesta a veracidade de todos os 
                            documentos enviados, concordando em que havendo condutas suspeitas de irregularidades, as mesmas 
                            serão passíveis de apuração de ilícito civil, penal e administrativo.</p>
                            <p align="justify">Ainda, declara que o endereço informado refere-se a atual localização do fornecedor (pessoa fisica ou juridica, nacional ou
                            estrangeira), e assume exclusivamente a responsabilidade por:</p>
                            <br>
                          <ol type="I" align="justify"> 
                          <li>Manter em sigilo a senha de acesso, não cabendo, em qualquer hipótese, alegação de uso indevido;</li>
                          <li>Conformidade entre os dados informados no formuláriode solicitação de cadastro e os constantes do documento protocolizado, incluindo o preenchimento dos campos obrigatórios e anexação dos documentos essenciais complementares;</li>
                          <li>Preenchimento da solicitação do cadastro e o upload dos documentos digitais em conformidade com os requisitos estabelecidos pelo Sistema, no que se refere ao formato e ao tamanho dos arquivos transmitidos eletronicamente;</li>
                          <li>Manutenção das vias originais dos documentos digitalizados enviados na solicitação do cadastro eletrônico, para que, caso solicitado, sejam apresentados para qualquer tipo deconferência pela Administração;</li>
                          <li>Realização por meio eletrônico de todas as solicitações, atualizações e comunicações entre o órgão/entidade responsável e o usuário, não sendo admitidas protocolização por meio diverso, exceto nas situações em que for tecnicamente inviável ou em caso de indisponibilidade do meio eletrônico cujo prolongamento cause dano relevante à celeridade da solicitação;</li>
                          <li>Acompanhamento, por meio do protocolo eletrônico da solicitação do cadastro e/ou atualização dos documentos transmitidos eletronicamente;</li>
                          <li>Assumir as condições de navegabilidade e segurança da rede de comunicação, o acesso ao provedor de internet e as configurações do computador utilizado nas transmissões eletrônicas;</li>
                          </ol>
                          <br>
                          <p align="justify">Para que a solicitação junto ao Cadastro de Fornecedores do Estado da Bahia - CAF seja liberada, o fornecedor (pessoa fisica ou juridica, nacional ou estrangeira) deverá enviar os seguintes documentos através do CAF-Digital:<br></p>
                          <p align="justify" class="recuo">
                          <strong>Para o fornecedor pessoa física (nacional ou estrangeira):</strong>
                          <br><br>
                          <ul>
                            <li>Termo de Declaração de Concordância e Veracidade assinado eletronicamente com Certificado Digital pessoa física <strong>ICP-BRASIL</strong>. </li>
                          </ul>
                          <br>
                          <strong>Para o fornecedor pessoa jurídica (nacional ou estrangeira):</strong>
                          <br><br>
                          <ul>
                            <li>Termo de Declaração de Concordância e Veracidade assinado eletronicamente com Certificado Digital pessoa jurídica ou física <strong>ICP-BRASIL</strong>.</li>
                          </ul>
                          </p>
                          <p align="justify" class="recuo2">
                          <ul>
                              Caso o Certificado Digital seja da pessoa fisica, deverá ser apresentado também os documentos abaixo:
                          </ul>
                          </p>
                          <p align="justify" class="recuo3">
                          <ul>
                            <li>Documento oficial de identificação que contenha foto dos sócios ou representante legal (RG, CNH, Carteira Profissional ou Passaporte);</li>
                            <li>Procuração, caso o Termo de Declaração de Concordância e Veracidade, seja assinado, eletrônicamente, pelo representante legal da empresa;</li>
                            <li>Contrato Social e suas últimas alterações contratuais ou documento equivalente.</li>
                          </ul>
                          </p>
                          <p align="justify">Na impossibilidade do Termo de Declaração de Concordância e Veracidade ser entregue digitalmente, será admitida a entrega no posto de Serviço de Atendimento ao Fornecedor – SAF ou em um dos Postos Avançados de Cadastro de Fornecedores - PCF. Os endereços atualizados podem ser verificados no site Comprasnet.BA em Fornecedor>Entrega de Documentos. Na entrega presencial, o Termo de Concordância e Veracidade deve ser acompanhado dos seguintes documentos:</p>
                          <p class="recuo" align="justify">
                          <strong>Para o fornecedor pessoa física (nacional ou estrangeira):</strong>
                          <br><br>
                          <ul>
                            <li>Original deste Termo de Declaração de Concordância e Veracidade, preenchido e assinado com firma reconhecida (ou com autenticação administrativa);</li>
                            <li>Original do documento oficial de identificação que contenha foto (RG, CNH, Carteira Profissional ou Passaporte) da pessoa física e cópia para fins de autenticação administrativa ou cópia autenticada em cartório;</li>
                            <li>Procuração, caso o Termo de Declaração de Concordância e Veracidade, seja assinado, eletrônicamente, pelo representante legal da empresa;</li>
                          </ul>
                          <br><br>
                          <strong>Para o fornecedor pessoa jurídica (nacional ou estrangeira):</strong>
                          <br><br>
                          <ul>
                            <li>Original deste Termo de Declaração de Concordância e Veracidade, preenchido e assinado com firma reconhecida (ou com autenticação administrativa);</li>
                            <li>Original do documento oficial de identificação que contenha foto (RG, CNH, Carteira Profissional ou Passaporte) dos sócios ou representante legal e cópia para fins de autenticação administrativa ou cópia autenticada em cartório;</li>
                            <li>Procuração, caso o Termo de Declaração de Concordância e Veracidade, seja assinado, eletrônicamente, pelo representante legal da empresa;	</li>
                            <li>Cartão do CNPJ da empresa;</li>
                            <li>Contrato Social e suas últimas alterações contratuais ou documento equivalente.</li>
                          </ul>
                          </p>
                        </td>
                      </tr>
                      <tr> 
                        <td ALIGN="LEFT"  width="50%">
                          <strong>Data:</strong> 
                        </td>
                        <td ALIGN="LEFT" width="50%" colspan="2">
                          <strong>Assinatura:</strong>  
                        </td>
                      </tr>
                  </table>                 
              </td>  
            </tr>
          </tbody>
          </table>
  
        </v-flex>
      <!-- </div> -->  

    </v-layout>
    
    <v-flex v-if="editar">
      <fornecedorrepresentantelegal :dados="model" :aberto="editar" :persistente='false'>
      </fornecedorrepresentantelegal>
    </v-flex>
    
  </div>

</template>

<script>


import fornecedorService from "../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
import dominioService from "../../services/dominioService";
import fornecedorrepresentantelegal from "./components/fornecedorrepresentantelegal";


import util from "../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import Print from "vue-print-nb";
import Vue from "vue";

export default {
  name: "termo-declaracao-concordancia",
  mixins: [util],
  components: { /*Componentes utilizados*/
    //mascote,
    fornecedorrepresentantelegal 
  },
  props: {//Propriedades que o objeto recebe como parametro
    idFornecSolicitacaoProps: Number, /* Id da Solicitacao atual do Fornecedor*/
    config: Number, 
  },
  data() {//Declaracao de variaveis
    return {
      printObj: { id: "conteudoImpressao", },
      enums: {
        tipoCertificado: []
      },
      valid: true,
      editar: false,
      model: {},
      OldModel: {},
      alteracaoModel: {},
      dominio: {
        categoria: [],
        paises: []
      },
      mascote: {
        msg: "Envio realizado com sucesso.",
        percent: 0
      },
      modelCarregado: false,
      VisivelOK : false,
      // dialogTermo: false,
    };
  },

  created() /*Metodo de start do componente*/{
    this.inicializar();
    Vue.use(Print);
  },
  methods: {//Declaracao de todos os metodos
    inicializar() {
      if (this.$route.params.id || this.idFornecSolicitacaoProps !== undefined) {
        this.visualizarSolicitacao();
        this.VisivelOK = this.idFornecSolicitacaoProps !== undefined;
      }
      this.getCombosDadosBasicos();
      dominioService.geEnums().then(response => { /*resposta do servico*/
        this.enums = response.data; /*dados de retorno*/
      });
    },
    imprimirConteudo() {
    // Abre a rota 'impressao' em uma nova aba
            window.open('/impressao', '_blank');
        },
    voltar_historico(){
      if (this.idFornecSolicitacaoProps !== undefined) {
        return true;
      } else {
        this.$router.push("/historico-solicitacoes");
      }
    },


    emitFecharModalToParent() {
      // Envia para o componente pai o status do modal, true = aberto, false = fechado

      if(this.$route.params.config == 1){     
        window.close();
      }

      if(this.$route.params.config != 3){
        this.voltar_historico();
        this.$emit('retornoDialogTermoFechar', false);
      }
      if(this.$route.params.config == 3){
      window.close();
      }
      //
    },      
    editarTermo(){
      this.editar = !this.editar;
      this.confirmaEdicaoImpressaoTermo();
    },
    voltar_pagina(){
      this.$router.push("/arearestrita/habilitador/solicitacao");
    },
    getCombosDadosBasicos() {
      //caregar combos de dados basicos
      dominioService.getCombosDadosBasicos().then(response => { /*resposta do servico*/
        this.dominio = response.data; /*dados de retorno*/
      });
    },

    visualizarSolicitacao() {
      //visualizar a solicitcao
      this.$mostrarPreload(); /*Exibir o PreLoad*/
      const idSolicitacao = this.idFornecSolicitacaoProps !== undefined ? this.idFornecSolicitacaoProps : this.$route.params.id;
      fornecedorService.getRepresentanteLegalUnico(idSolicitacao).then(response => { /*resposta do servico*/
      
        this.model = response.data; /*dados de retorno*/
    
        this.modelCarregado = true;
        this.$removePreload(); /*Ocultar o PreLoad*/
      }).catch(error => {
        this.$removePreload(); /*Ocultar o PreLoad*/
        if (error.status == 403) {
          Vue.toasted.error("Acesso não permitido!");
          this.$router.push("/historico-solicitacoes");
        }
      });
    },
    retornaEnumChave(_enum, valor) {
      //retorna a chave do enum
      if (valor == null || this.enums[_enum] == null) return "";
      let retorno = this.enums[_enum].find(x => x.valor === valor);
      return retorno ? retorno.chave : null;
    },

    retornaEnumDescricao(_enum, valor) {
      //retorna a descricao do enum
      if (valor == null || !this.enums[_enum] == null) return "";
      let retorno = this.enums[_enum].find(x => x.valor === valor);
      return retorno ? retorno.descricao : null;
    },
    retornaCategoria(cod_categoria) {
      //retorna a categoria
      if (!cod_categoria) return "";
      let categoria = this.dominio.categoria.find(
        x => x.categoria === cod_categoria
      );
      return categoria ? categoria.descricao : null;
    },

    //Confirma a edição e impressao do termo alterando a solicitação para "Aguardando Análise"
    //Somente é executado se a situação da solicitação for "Rejeitar"(10)
    confirmaEdicaoImpressaoTermo(){
      if(this.model.idFornecSolicitacao != null && this.model.situacaoSolicitacao === 10)
      {
        fornecedorService.confirmaEdicaoImpressaoTermo(this.model.idFornecSolicitacao);
      }
    }
  }
};
</script>
<style scoped> /*CSS especifico do componente*/
.textoBoasVindas h1 {
  font-size: 40px;
  
}
.textoBoasVindas {
  top:10px;
  left: 10px;
}

.nomeFornecedor {
  position: relative;
}

.boxConteudoNomeFornecedor {
  background: url("/images/bg1.png") repeat center center;
  border: 1px solid #cdcdcd;
  position: absolute;
  text-align: center;
  top: 50%;
  transform: translateY(-25%);
  width: calc(100% - 30px);
  z-index: 999;
  padding: 10px 0;
}
</style>
<style scoped> /*CSS especifico do componente*/
.theme--light.v-table thead {
  background: none;
  color: red;
}

td{
  padding:4px;
}

@page { 
  size: portrait;
  margin: 25mm 25mm 25mm 25mm;
}

ol{
  padding-left: 5.5em;
}

li {
  text-indent: 1.0em;
}

.recuo{
  margin-left: 3.5em;
}

.recuo2{
  margin-left: 6.0em; 
}

.recuo3{
  margin-left: 8.5em;
}

</style>



